import React from "react";
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getApi } from "../../api/endpoints";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { selectQueryParams, setQueryParams, updateQueryParams } from "../../ui/customerListingReducer";

const ArchiveUnarchiveModal = (props) => {
  const {showArchiveUnarchiveModal, setShowArchiveUnarchiveModal, operatorDetails} = props;
  const [archiveOpeartorApi] = getApi('archiveOperator');
  const [unArchiveOpeartorApi] = getApi('unArchiveOperator');
  const queryParams = useSelector(selectQueryParams);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    setShowArchiveUnarchiveModal(false);
  }

  const onArchiveOperatorClick = async () => {
    try{
      const response = await archiveOpeartorApi({id: `${operatorDetails.id}`}).unwrap();
      setShowArchiveUnarchiveModal(false);
      toast.success(response.message || 'Operator Archived !');
      dispatch(updateQueryParams(setQueryParams(queryParams)));
    } catch(error) {
      setShowArchiveUnarchiveModal(true);
      toast.error(error?.message || 'Something went wrong !');
    }
  }

  const onUnarchiveOperatorClick = async () => {
    try{
      const response = await unArchiveOpeartorApi({id: `${operatorDetails.id}`}).unwrap();
      toast.success(response.message || 'Operator Unarchived !');
      setShowArchiveUnarchiveModal(false);
      dispatch(updateQueryParams(setQueryParams(queryParams)));
    } catch(error) {
      setShowArchiveUnarchiveModal(true);
      toast.error(error?.message || 'Something went wrong !');
    }
  }

  return <>
    {operatorDetails?.archived === true ?
      <Modal
        show={showArchiveUnarchiveModal}
        onHide={handleModalClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          style={{ backgroundImage: 'linear-gradient(103deg, #49c12b 0, #197800 99%)' }}
          className="text-white"
          closeButton
        >
          <Modal.Title>Unarchive Opeartor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='text-center m-2 text-warning'><FontAwesomeIcon icon={faCircleExclamation} style={{ fontSize: '80px'}}/></div>
          <p className='h4 text-center my-3 opacity-75'>Are you sure ?</p>
          <p className='h6 text-center my-3 opacity-75 fw-normal'>
            You want to unarchive <span className="fw-bold">{operatorDetails.name} ({operatorDetails.id})</span> ?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-sm rounded-5 btn-outline-secondary" style={{ width: "80px", fontSize: '16px' }} onClick={handleModalClose}>
            Cancel
          </button>
          <button type='submit' className='btn btn-sm add-button' style={{ width: "100px", fontSize: '16px' }} onClick={(e) => {e.preventDefault(); onUnarchiveOperatorClick()}}>
            Unarchive
          </button>
        </Modal.Footer>
      </Modal> :
      <Modal
        show={showArchiveUnarchiveModal}
        onHide={handleModalClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          style={{ backgroundImage: 'linear-gradient(103deg, #49c12b 0, #197800 99%)' }}
          className="text-white"
          closeButton
        >
          <Modal.Title>Archive Opeartor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='text-center m-2 text-warning'><FontAwesomeIcon icon={faCircleExclamation} style={{ fontSize: '80px'}}/></div>
          <p className='h4 text-center my-3 opacity-75'>Are you sure ?</p>
          <p className='h6 text-center my-3 opacity-75 fw-normal'>
            You want to archive <span className="fw-bold">{operatorDetails.name} ({operatorDetails.id})</span> with wallet balance <span className="fw-bold">{operatorDetails.wallet_balance}</span> ?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-sm rounded-5 btn-outline-secondary" style={{ width: "80px", fontSize: '16px' }} onClick={handleModalClose}>
            Cancel
          </button>
          <button type='submit' className='btn btn-sm remove-button' style={{ width: "80px", fontSize: '16px' }} onClick={(e) => {e.preventDefault(); onArchiveOperatorClick()}}>
            Archive
          </button>
        </Modal.Footer>
      </Modal>
    }
  </>
}

export default ArchiveUnarchiveModal;
